'use strict';

/**
 * This is our global app instance that governs the locale, currency and other
 * stuff we have to have around everywhere in the app.
 *
 * It gets added to Vue through the prototype Vue.prototype.$App in vue-bootstrap.js
 */
const App = {
	baseUrl: '/',
	locale: 'en',
	getLocale: function() {
		let regex = new RegExp('\/[a-z]{2}\/|\/[a-z]{2}$');
		let result = regex.exec(window.location.href);

		if (result === null) {
			return App.locale;
		}

		App.locale = result[0].replace(/\//g, '');

		return App.locale;
	},
};

export default App;
